import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { FaStar, FaChevronLeft } from 'react-icons/fa';
import APIURL from '../../common/Config';
import IMAGEURL from '../../common/ImageURLConfig';
import Header from '../header/header';
import './feedback.css';
import toast from 'react-hot-toast';

const Feedback = () => {
    const { sessionId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const [rating, setRating] = useState(0);
    const [clarity, setClarity] = useState('');
    const [responseSpeed, setResponseSpeed] = useState('');
    const [satisfaction, setSatisfaction] = useState('');
    const [consultAgain, setConsultAgain] = useState('');
    const [engagement, setEngagement] = useState('');
    const [remedy, setRemedy] = useState('');
    const [comments, setComments] = useState('');
    const [astrologerName, setAstrologerName] = useState('Astrologer');

    const ratingLabels = ['Very Poor', 'Poor', 'Average', 'Good', 'Excellent'];

    useEffect(() => {
        const name = localStorage.getItem('astrologerName');
        if (name) setAstrologerName(name);
    }, []);

    const submitReview = async () => {
        const astrologerId = localStorage.getItem('selectedAstrologerId');
        const customerId = localStorage.getItem('customerId');

        if (!clarity || !responseSpeed || !satisfaction || !consultAgain || !engagement || !remedy || rating === 0) {
            // alert("Please fill all fields before submitting.");
            toast.error("Please fill all fields before submitting.");
            return;
        }

        const payload = {
            astrologerId: parseInt(astrologerId),
            customerId: parseInt(customerId),
            overallRating: rating,
            clarityOfAnswers: clarity,
            responseSpeed: responseSpeed,
            satisfactionLevel: satisfaction,
            likelihoodToConsult: consultAgain,
            sessionEngagement: engagement,
            remediesSuggested: remedy,
            reviewComment: comments,
            submittedAt: new Date().toISOString(),
        };

        try {
            await axios.post(`${APIURL}/api/reviews`, payload);
            // alert("Success: Review submitted successfully!");
            toast.success("Review submitted successfully!");
            navigate('/'); 
        } catch (error) {
            // alert("Submission Failed");
            toast.error("Submission Failed. Please try again.");
        }
    };

    const renderOptionRow = (currentVal, setter) => (
        <div className="feedback-button-row">
            {ratingLabels.map((label) => (
                <button
                    key={label}
                    className={`feedback-option-btn ${currentVal === label ? 'selected' : ''}`}
                    onClick={() => setter(label)}
                >
                    {label}
                </button>
            ))}
        </div>
    );

    return (
        <div className="feedback-page-wrapper">
            <div className="feedback-header">
                <FaChevronLeft className="back-icon" onClick={() => navigate(-1)} />
                <span>Rate Your Sessions</span>
                <span className="skip-btn" onClick={() => navigate('/')}>Skip</span>
            </div>

            <div className="feedback-scroll-content">
                {/* Intro Card */}
                <div className="feedback-card">
                    <p className="feedback-intro-text">
                        We’d love to hear your valuable feedback on the session with{' '}
                        <span className="astro-name-highlight">{astrologerName}</span> — it helps us improve and serve you better.
                    </p>
                </div>
                {/* Overall Rating */}
                <div className="feedback-card">
                    <div className="card-heading-row">
                        <img src={`${IMAGEURL}/assets/RateYourSessions/OverallRating.png`} alt="icon" />
                        {/* <img src="../../assets/image/NEW IMAGESSS/OverallRating.png" alt="" /> */}
                        <h3>Overall Rating</h3>
                    </div>
                    <div className="star-row">
                        {[1, 2, 3, 4, 5].map((i) => (
                            <FaStar
                                key={i}
                                className={`star-icon ${rating >= i ? 'active' : ''}`}
                                onClick={() => setRating(i)}
                            />
                        ))}
                    </div>
                    {rating > 0 && <p className="rating-desc">{ratingLabels[rating - 1]}</p>}
                </div>

                {/* Chat Performance */}
                <div className="feedback-card">
                    <div className="card-heading-row">
                        <img src={`${IMAGEURL}/assets/RateYourSessions/ChatPerformance.png`} alt="icon" />
                        <h3>Chat Performance</h3>
                    </div>
                    <label>Clarity of answers:</label>
                    {renderOptionRow(clarity, setClarity)}
                    <div className="feedback-divider" />
                    <label>Response speed:</label>
                    {renderOptionRow(responseSpeed, setResponseSpeed)}
                </div>

                {/* Session Experience */}
                <div className="feedback-card">
                    <div className="card-heading-row">
                        <img src={`${IMAGEURL}/assets/RateYourSessions/SessionExperience.png`} alt="icon" />
                        <h3>Session Experience</h3>
                    </div>
                    <label>How satisfied were you?</label>
                    {renderOptionRow(satisfaction, setSatisfaction)}
                    <label>Likelihood to consult again?</label>
                    {renderOptionRow(consultAgain, setConsultAgain)}
                    <div className="feedback-divider" />
                    <label>Session engagement:</label>
                    {renderOptionRow(engagement, setEngagement)}
                </div>

                {/* Remedies */}
                <div className="feedback-card">
                    <div className="card-heading-row">
                        <img src={`${IMAGEURL}/assets/RateYourSessions/RemediesGuidance.png`} alt="icon" />
                        <h3>Remedies & Guidance</h3>
                    </div>
                    <label>Were remedies suggested?</label>
                    <div className="feedback-button-row">
                        {['Yes', 'No', 'N/A'].map((opt) => (
                            <button
                                key={opt}
                                className={`feedback-option-btn small ${remedy === opt ? 'selected' : ''}`}
                                onClick={() => setRemedy(opt)}
                            >
                                {opt}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Comments */}
                <div className="feedback-card">

                    <div className="card-heading-row">
                        <img src={`${IMAGEURL}/assets/RateYourSessions/AdditionalComments.png`} alt="icon" />
                        <h3>Additional Comments</h3>
                    </div>
                    <textarea
                        className="feedback-textarea"
                        placeholder="Share any other thoughts, suggestions, or specific praises..."
                        value={comments}
                        onChange={(e) => setComments(e.target.value)}
                    />
                </div>

                {/* Submit Button */}
                <button className="feedback-submit-btn-fixed" onClick={submitReview}>
                    <img src={`${IMAGEURL}/assets/RateYourSessions/SubmitYourFeedback.png`} alt="submit" />
                    Submit Your Feedback
                </button>
            </div>
        </div>
    );
};

export default Feedback;